import Vue from 'vue'
import VueComponent from './Tabs.vue'

let tabs = document.querySelectorAll('.vue-component-tabs')

tabs.forEach(tab => {
  new Vue({
    render: h => h(VueComponent, {props: {id:tab.id}}),
  }).$mount(`#${tab.id}`)
}) 